const benefits = [
  {
    icon: 'iconoir-user-xmark',
    title: 'Zero Setup Friction',
    description:
      'Eliminate manual registration entirely. Users receive YubiKeys that are already enrolled with your identity provider\u2014ready to authenticate on first use.',
    metric: '0 minutes setup time',
  },
  {
    icon: 'iconoir-shield',
    title: 'Phishing-Resistant From Day 1',
    description:
      'Hardware-backed FIDO2 authentication provides the highest level of protection. No shared secrets, no passwords\u2014attackers have nothing to steal.',
    metric: '100% phishing protection',
  },
  {
    icon: 'iconoir-headset',
    title: 'Reduced IT Overhead',
    description:
      'No more support tickets for key registration issues. No training users through complex enrollment flows. IT teams can focus on strategic initiatives.',
    metric: '-92% support tickets',
  },
]

function BenefitsCards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {benefits.map((benefit) => (
        <div
          key={benefit.title}
          className="bg-white rounded-2xl p-6 border border-gray-200 stat-card"
        >
          <div className="w-14 h-14 bg-yubico-green-50 rounded-full flex items-center justify-center mb-4">
            <i className={`${benefit.icon} text-yubico-green-400 text-3xl`}></i>
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h4>
          <p className="text-gray-600 leading-relaxed mb-4">{benefit.description}</p>
          <div className="font-mono text-sm text-yubico-green-500 font-bold">
            {benefit.metric}
          </div>
        </div>
      ))}
    </div>
  )
}

export default BenefitsCards
